import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { LegalLayout, InfoBlock, type LegalSection } from "@/components/calv/LegalLayout";

const sections: LegalSection[] = [
  {
    id: "anbieter",
    num: "01",
    title: "Angaben gemäß § 5 TMG",
    content: (
      <InfoBlock>
        calvarius GmbH<br />
        Kalvarienberg 20<br />
        97753 Karlstadt<br />
        Deutschland
      </InfoBlock>
    ),
  },
  {
    id: "vertretung",
    num: "02",
    title: "Vertreten durch",
    content: (
      <p>
        Geschäftsführer: <strong>André Freier</strong>
      </p>
    ),
  },
  {
    id: "kontakt",
    num: "03",
    title: "Kontakt",
    content: (
      <InfoBlock>
        Telefon: +49 9353 9768 000<br />
        Telefax: +49 9353 9768 911<br />
        E-Mail: <a href="mailto:info@calvarius.com">info@calvarius.com</a>
      </InfoBlock>
    ),
  },
  {
    id: "register",
    num: "04",
    title: "Handelsregister",
    content: (
      <p>
        Eingetragen im Handelsregister beim Amtsgericht Würzburg<br />
        Handelsregisternummer: <strong>HRB 11938</strong>
      </p>
    ),
  },
  {
    id: "steuer",
    num: "05",
    title: "Steuerliche Angaben",
    content: (
      <>
        <p>Steuernummer: 231/123/00058</p>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:{" "}
          <strong>DE289667074</strong>
        </p>
      </>
    ),
  },
  {
    id: "verantwortlich",
    num: "06",
    title: "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV",
    content: (
      <InfoBlock>
        André Freier<br />
        Kalvarienberg 20<br />
        97753 Karlstadt<br />
        Deutschland
      </InfoBlock>
    ),
  },
  {
    id: "haftung-inhalte",
    num: "07",
    title: "Haftung für Inhalte",
    content: (
      <p>
        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
        Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
        Als Diensteanbieter sind wir gemäß den gesetzlichen Bestimmungen für eigene Inhalte auf
        diesen Seiten verantwortlich, jedoch nicht verpflichtet, übermittelte oder gespeicherte
        fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
        rechtswidrige Tätigkeit hinweisen.
      </p>
    ),
  },
  {
    id: "haftung-links",
    num: "08",
    title: "Haftung für Links",
    content: (
      <p>
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen
        Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
        übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
        Betreiber der Seiten verantwortlich.
      </p>
    ),
  },
  {
    id: "urheber",
    num: "09",
    title: "Urheberrecht",
    content: (
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
        dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
        der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen
        Zustimmung des jeweiligen Autors bzw. Erstellers.
      </p>
    ),
  },
  {
    id: "streit",
    num: "10",
    title: "Hinweis zur Online-Streitbeilegung",
    content: (
      <>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
          bereit:{" "}
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
            ec.europa.eu/consumers/odr
          </a>
          .
        </p>
        <p>
          Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor
          einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </>
    ),
  },
];

export const Route = createFileRoute("/impressum")({
  head: () => {
    const h = pageHead("imprint", "de");
    return { meta: h.meta, links: h.links };
  },
  component: () => (
    <LegalLayout
      eyebrow="Imp."
      title="Impressum"
      meta="Angaben gemäß § 5 TMG"
      crumbLabel="Impressum"
      sections={sections}
    />
  ),
});
